const Urls = {
	Api: {
		cart: '/my/cart',
		product: '/my/api/2/shopping-cart/active/product',
		product_options_manual: function( product_id ) {
			return '/my/api/2/shopping-cart/active/product/' + product_id + '/option/manual';
		},
		product_related: '/my/api/2/shopping-cart/active/related',
		up_sale_promos_apply: function( promo_id ) {
			return '/my/api/2/shopping-cart/active/upsale-promos/' + promo_id + '/apply';
		},
		get_template_url: function( template_url ) {
			//return '/my/api/2/templates?name=' + template_url;
			return template_url;
		},
		bundle: '/my/api/2/shopping-cart/active/bundle'
	},
	Templates: {
		app: '/my/api/2/templates?name=modules/add-to-cart/app.html',
		modal: '/my/api/2/templates?name=modules/add-to-cart/modal.html',
		accessory_modal: '/my/api/2/templates?name=modules/add-to-cart/accessory-modal.html',
		sticky_footer: '/my/api/2/templates?name=modules/add-to-cart/sticky-footer.html',
		message: '/my/api/2/templates?name=modules/add-to-cart/message.html'
	}
};

export default Urls;